import { render, staticRenderFns } from "./ServeCenterDetail.vue?vue&type=template&id=2ce5af8a&scoped=true&"
import script from "./ServeCenterDetail.vue?vue&type=script&lang=js&"
export * from "./ServeCenterDetail.vue?vue&type=script&lang=js&"
import style0 from "./ServeCenterDetail.vue?vue&type=style&index=0&id=2ce5af8a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce5af8a",
  null
  
)

export default component.exports